<div class="toolbar-user" (furyClickOutside)="onClickOutside()">
  <button class="user-pill-btn" (click)="toggleDropdown()" [class.open]="isOpen" type="button">
    <div class="user-avatar-badge">{{ userInitial }}</div>
    <span class="user-name" fxHide fxShow.gt-sm>Welcome, {{ userName }}!</span>
    <mat-icon class="chevron-icon" fxHide fxShow.gt-sm>keyboard_arrow_down</mat-icon>
  </button>

  <div class="dropdown" [class.open]="isOpen">
    <!-- User summary card -->
    <div class="user-dropdown-header">
      <div class="header-avatar">{{ userInitial }}</div>
      <div class="header-details">
        <div class="header-name">{{ userName }}</div>
        @if (user?.email) {
          <div class="header-email">{{ user.email }}</div>
        }
        @if (user?.userType) {
          <span class="header-badge">{{ user.userType }}</span>
        }
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="list">
      @if (authService.isInRole(['Admin'])) {
        <div class="list-item" matRipple [routerLink]="['/account/change-password']" (click)="onClickOutside()">
          <div class="item-icon-wrap">
            <mat-icon class="list-item-icon">lock_reset</mat-icon>
          </div>
          <span>Change password</span>
        </div>
      }
      <mat-divider></mat-divider>
      <div class="list-item logout-item" matRipple (click)="authService.logout(); onClickOutside()">
        <div class="item-icon-wrap logout-wrap">
          <mat-icon class="list-item-icon logout-icon">logout</mat-icon>
        </div>
        <span>Logout</span>
      </div>
    </div>
  </div>
</div>